/**
 * 包含答题和报告，报告分享的路由
 */

import {
  loadPageFail
} from '../lib/units';

export default [{
    name: 'answerFrame',
    path: '/answer',
    meta: {
      title: '答题初始化页面'
    },
    component: resolve => require(['../pages/answer/answer.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '答题初始化页',
        err
      })
    }),
    children: [{
        name: 'answerGender',
        path: 'gender',
        meta: {
          title: '答题性别选择页',
        },
        component: resolve => require(['../pages/answer/answerGender.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '性别选择页',
            err
          })
        })
      },
      {
        name: 'answerState',
        path: 'state',
        meta: {
          title: '答题测试说明页',
        },
        component: resolve => require(['../pages/answer/answerState.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '测试说明页',
            err
          })
        })
      },
      {
        name: 'answerList',
        path: 'list',
        meta: {
          title: '答题页',
        },
        component: resolve => require(['../pages/answer/answerList.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '答题页',
            err
          })
        })
      },
      {
        name: 'answerList2',
        path: 'list2',
        meta: {
          title: '答题页',
        },
        component: resolve => require(['../pages/answer/answerList2.vue'], resolve, (err) => {
          console.log(err.message);
          alert('加载页面失败')
        })
      },
      // 新房树人
      {
        name: 'htpState',
        path: 'htpState',
        meta: {
          title: '答题测试说明页',
        },
        component: resolve => require(['../pages/houseTreePerson/htpState.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '测试说明页',
            err
          })
        })
      },
      {
        name: 'htpPainting',
        path: 'htpPainting',
        meta: {
          title: '绘画页',
        },
        component: resolve => require(['../pages/houseTreePerson/htpPainting.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '绘画页',
            err
          })
        })
      },
      {
        name: 'answerPainting',
        path: 'painting',
        meta: {
          title: '照片上传页',
        },
        component: resolve => require(['../pages/houseTreePeople/answerPainting.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '照片上传页',
            err
          })
        })
      },
      {
        name: 'answerListHtp',
        path: 'listHtp',
        meta: {
          title: '房树人答题页',
          newZhugeTitle: '房树人',
        },
        component: resolve => require(['../pages/houseTreePeople/answerList.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '房树人答题页',
            err
          })
        })
      },
      {
        name: 'answerListChildDraw',
        path: 'listChildDraw',
        meta: {
          title: '答题页',
        },
        component: resolve => require(['../pages/houseTreePeople/answerListChildDraw.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '答题页',
            err
          })
        })
      },
      {
        name: 'answerTransfer',
        path: 'transfer',
        meta: {
          title: '答题中转页',
        },
        component: resolve => require(['../pages/answer/transfer.vue'], resolve, (err) => {
          alert('加载页面失败')
        })

      },
      {
        name: 'topAnswerList',
        path: 'topAnswerList',
        meta: {
          title: '答题页',
        },
        component: resolve => require(['../pages/techa/topAnswerList.vue'], resolve, (err) => {
          console.log(err.message);
          alert('加载页面失败')
        })
      },
      {
        name: 'testInstructions',
        path: '/testInstructions',
        meta: {
          title: '测试须知',
        },
        component: resolve => require(['../pages/testInstructions/index.vue'], resolve, (err) => {
          console.log(err.message);
          alert('加载页面失败')
        })
      },
    ]
  },
  {
    name: 'login',
    path: '/login',
    meta: {
      title: '登录/注册'
    },
    component: resolve => require(['../pages/answer/login.vue'], resolve)
  },
  {
    name: 'finishTips',
    path: '/finishTips',
    meta: {
      title: '测评完成'
    },
    component: resolve => require(['../pages/answer/finishTips.vue'], resolve)
  },
  {
    name: 'applyAssign',
    path: '/applyAssign',
    meta: {
      title: '申请分配测评'
    },
    component: resolve => require(['../pages/answer/applyAssign.vue'], resolve)
  },
  {
    name: 'auditStatus',
    path: '/auditStatus',
    meta: {
      title: ''
    },
    component: resolve => require(['../pages/answer/auditStatus.vue'], resolve)
  },
  {
    path: '/report',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/report/index.vue'], resolve),
    children: [{
        name: 'testReport',
        path: '/',
        meta: {
          title: '报告页',
        },
        component: resolve => require(['../pages/report/report.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '报告页',
            err
          })
        }),
      },
      {
        name: 'reportPreview',
        path: 'preview',
        meta: {
          title: '报告分享预览'
        },
        component: resolve => require(['../pages/report/sharePreview.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '报告分享预览页',
            err
          })
        }),
      },
      {
        name: 'shareReport',
        path: 'share/:employeeScaleId/:scaleId/:companyScaleId/:username/:isBackRequest/:isDisplayVote/:channelId',
        meta: {
          title: '报告分享页'
        },
        component: resolve => require(['../pages/report/shareReport.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '报告分享页',
            err
          })
        }),
      },
    ]
  },
  {
    path: '/report2',
    name:'report2',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/report/2.0.vue'], resolve),
  },
  {
    path: '/report2_test',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/report/inShare04.vue'], resolve),
  },
  {
    path: '/genenalReport',
    meta: {
      title: '报告聚合页',
    },
    component: resolve => require(['../pages/report/genenalReport.vue'], resolve),
  },
  {
    name: 'readingReport',
    path: '/readingReport',
    meta: {
      title: '报告解读',
    },
    component: resolve => require(['../pages/report/readingReport.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '报告解读页',
        err
      });
    })
  },
  {
    name: 'showWishes',
    path: '/showWishes',
    meta: {
      title: '晒一晒',
    },
    component: resolve => require(['../pages/report/showWishes.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '晒一晒',
        err
      });
    })
  },
  {
    name: 'voiceDetail',
    path: '/voiceDetail',
    meta: {
      title: '分享落地页',
    },
    component: resolve => require(['../pages/show/voiceDetail.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '分享落地页',
        err
      });
    })
  },
  {
    name: 'reportPdf',
    path: '/reportPdf/:accountId/:channelId/:uid/:enterFrom/:tabModuleId/:userKey/:userNickName',
    meta: {
      title: '报告页Pdf',
    },
    component: resolve => require(['../pages/report/reportPdf.vue'], resolve),
  },
  {
    path: '/topReport',
    name:'topReport',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/techaReport/2.0.vue'], resolve),
  },
  {
    path: '/newReport',
    name:'newReport',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/newReport/1.0.vue'], resolve),
  },
  {
    name: 'newreportPdf',
    path: '/newreportPdf/:accountId/:channelId/:uid/:enterFrom/:tabModuleId/:userKey/:userNickName',
    meta: {
      title: '报告页Pdf',
    },
    component: resolve => require(['../pages/newReport/1.0.vue'], resolve),
  },
  {
    name: 'scl90Report',
    path: '/scl90Report',
    mata:{
      title: '订制报告'
    },
    component: resolve => require(['../pages/newReport/scl90Report.vue'], resolve)
  },
  {
    name: 'generalReport',
    path: '/generalReport',
    meta: {
      title: '报告聚合页',
    },
    component: resolve => require(['../pages/newReport/generalReport.vue'], resolve),
  },
  {
    name: 'inreadingTopreport',
    path: '/inreadingTopreport',
    meta: {
      title: '高价测试报告页-组件调页面',
    },
    component: resolve => require(['../components/techa/inreadingReport.vue'], resolve),
  },
  {
    path: '/zxSalesQrcode',
    name:'zxSalesQrcode',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../components/newReport/zixun-sales-qrcode.vue'], resolve),
  },
]



// WEBPACK FOOTER //
// ./src/router/answer_report.js